import styled from "styled-components";
import { getColor } from "../../../styling/mixins/colors";
import { text } from "../../../styling/mixins/typography";
import { fontFamilyBold } from "../../../styling/variables/typography";

export const SuggestedProductCardRow = styled.div`
  background-color: ${getColor('white')};
  display: flex;
  flex-direction: row;
  gap: 0 1.6rem;
  margin-top: 0.4rem;
  border: 1px solid ${getColor('gray', 200)};
  padding: 1.6rem 5rem 1.6rem 4.5rem;

  .top-section {
    display: flex;
    flex-direction: row;
  }
  .right-section {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .image-wrapper {
    background-color: ${getColor('white')};
    width: 64px;
    height: 64px;
  }

  .image {
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: contain;
  }

  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .name {
    ${text('medium')}
    ${fontFamilyBold}
    margin-bottom: 0.8rem;
  }

  .description {
    margin-bottom: 0.8rem;
    .name-description {
      ${text('small')};
      color: ${getColor('gray', 600)};
    }
  }

  .price-wrapper {
    ${text('large')}
    ${fontFamilyBold}
    text-align: right;
    &--discount {
      color: ${getColor('alert')};
      .price {
      }
    }
  }

  .price {
    ${text('small')}
    text-decoration: line-through;
    color: ${getColor('grey', 500)};
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;



export const SuggestedProductCardRowDesktop = styled.div`
  background-color: ${getColor('white')};
  display: flex;
  flex-direction: row;
  padding: 1.6rem 5rem 1.6rem 4.5rem;
  border: 1px solid ${getColor('gray', 200)};

  .image-wrapper {
    background-color: ${getColor('white')};
    width: 71px;
    height: 78px;
  }

  .image {
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: contain;
  }
`;

export const SuggestedProductCardCheckoutRow = styled.div`
  background-color: ${getColor('white')};
  display: grid;
  grid-template-rows: 145px 34px 24px 24px 17px 34px;
  gap: 10px;
  height: 100%;
  align-content: start; // Ensures content starts from the top
  text-align: center;
  align-items: baseline;
  padding: 10px 0px;

  .image-wrapper {
    background-color: ${getColor('white')};
    width: 133px;
    min-height: 145px;
    justify-self: center;
  }

  .image {
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: contain;
  }
`;